export default "__VITE_ASSET__Y6xj0nx5__"